import styled from '@emotion/styled';
import React from 'react';
import { DocumentDetail } from '@app/api/public/DocumentsApi';
import useGetSingedUrlById from '../../../lib/hooks/useGetSingedUrlById';

const StyledDocumentRow = styled.a({
    textDecoration: 'none',
    display: 'block',
    fontSize: '12px',
    cursor: 'pointer',
    color: 'inherit',
});

const PublicDocumentRow = ({ document }: { document: DocumentDetail }) => {
    return (
        <StyledDocumentRow href={document?.document_data?.public_url} target="_blank" rel="noreferrer">
            {document.name}
        </StyledDocumentRow>
    );
};

export default PublicDocumentRow;
